import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/subdistricts'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'subdistricts'

export const metadata = {
  icon: 'flag-o',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const SubdistrictsListPage = createListPage({ metadata, api, actionCreators, Content })
const SubdistrictsDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { SubdistrictsListPage, SubdistrictsDetailPage }
